import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

/* Layout */
import Layout from '@/layout';

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
    hiddenMenu:true              hide sidebar if need
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */

const SEC_SEND_PAGE_TITLE = {
  add: '新建活动',
  edit: '编辑活动',
  copy: '复制活动',
  view: '查看活动',
};

// 店铺概况路由
const storeProfileRoutes = {
  path: '/shop-situation',
  component: Layout,
  name: 'shop-situation',
  meta: {
    title: '店铺概况',
    icon: 'iconshangpin-',
  },
  children: [
    {
      path: '/shop-situation',
      name: 'shop-situation',
      component: () =>
        import('@/views/shop-situation/components/abnormal-prompt.vue'),
      hidden: true,
    },
  ],
};

// 店铺管理路由
const shopManageRoutes = {
  path: '/shop-decoration',
  component: Layout,
  name: 'shop-decoration',
  meta: {
    title: '店铺管理',
    icon: 'iconshangpin-',
  },
  children: [
    {
      path: 'shop-list',
      component: () => import('@/views/shop-decoration/shop-list/main.vue'),
      name: 'shop-list-main',
      meta: {
        title: '店铺装修',
        icon: 'iconshangpin-',
      },
      children: [
        {
          path: 'shop-detail',
          component: () =>
            import('@/views/shop-decoration/shop-detail/shop-detail.vue'),
          name: 'shop-detail',
          hidden: true,
          meta: {
            title: '店铺装修',
            icon: 'iconshangpin-',
            hiddenMenu: true,
          },
        },
        {
          path: 'index',
          component: () =>
            import('@/views/shop-decoration/shop-list/shop-list.vue'),
          name: 'shop-list',
          hidden: true,
          meta: {
            title: '店铺装修列表',
            icon: 'iconshangpin-',
          },
        },
        {
          path: 'prev-picture',
          component: () =>
            import(
              '@/views/shop-decoration/home-decoration/prevpicture/prevpicture.vue'
            ),
          name: 'prev-picture',
          hidden: true,
          meta: {
            title: '预览',
            icon: 'iconshangpin-',
            hiddenMenu: true,
          },
        },
        {
          path: '/',
          redirect: 'index',
          hidden: true,
        },
      ],
    },
    {
      path: 'hot-words-list',
      component: () =>
        import('@/views/shop-decoration/hot-words-list/hot-words-list.vue'),
      name: 'hot-words-list',
      meta: {
        title: '搜索页',
        icon: 'iconshangpin-',
      },
    },
    {
      path: 'multimedia-material',
      component: () =>
        import(
          '@/views/shop-decoration/multimedia-material/multimedia-material.vue'
        ),
      name: 'multimedia-material',
      meta: {
        title: '素材管理',
        icon: 'iconshangpin-',
      },
    },
    {
      path: 'server-deploy',
      component: () =>
        import('@/views/shop-decoration/server-deploy/server-deploy.vue'),
      name: 'server-deploy',
      meta: {
        title: '商城服务配置',
        icon: 'iconshangpin-',
      },
    },
    {
      path: 'channel-manage',
      name: 'channel-manage',
      // component: () => import('@/views/user-manager/user-list'),
      meta: {
        title: '渠道管理',
        icon: 'iconshangpin-',
      },
    },
    {
      path: 'suspension',
      name: 'suspension',
      // component: () => import('@/views/user-manager/user-list'),
      meta: {
        title: '悬浮窗',
        icon: 'iconshangpin-',
      },
    },
  ],
};

const distributionRoutes = {
  path: 'distribution',
  name: 'distribution',
  component: Layout,
  meta: {
    title: '我要分销',
    icon: 'iconshangpin-',
  },
  children: [
    {
      path: 'goods-market',
      name: 'goods-market',
      meta: {
        title: '分销市场',
        icon: 'iconshangpin-',
      },
    },
    {
      path: 'goods-change',
      name: 'goods-change',
      meta: {
        title: '商品变更',
        icon: 'iconshangpin-',
      },
    },
    {
      path: 'distributor-account',
      name: 'distributor-account',
      meta: {
        title: '我的账户',
        icon: 'iconshangpin-',
      },
    },
    {
      path: 'orders',
      name: 'orders',
      meta: {
        title: '分销订单结算',
        icon: 'iconshangpin-',
      },
    },
    {
      path: 'price-handle',
      name: 'price-handle',
      meta: {
        title: '自动调价工具',
        icon: 'iconshangpin-',
      },
    },
  ],
};

// CPC广告投放
const cpcAdsRoutes = {
  path: 'cpc-ads',
  name: 'cpc-ads',
  component: Layout,
  meta: {
    title: 'CPC广告投放',
    icon: 'iconshangpin-',
  },
  children: [
    {
      path: 'delivery-channel',
      name: 'delivery-channel',
      meta: {
        title: '投放渠道管理',
        icon: 'iconshangpin-',
      },
    },
    {
      path: 'delivery-link',
      name: 'delivery-link',
      meta: {
        title: '投放链接管理',
        icon: 'iconshangpin-',
      },
    },
  ],
};

// 商品管理路由
const goodManageRoutes = {
  path: '/good-manage',
  name: 'good-manage-layout',
  component: Layout,
  meta: {
    title: '商品管理',
    icon: 'iconshangpin-',
  },
  children: [
    {
      path: 'good-group',
      name: 'good-group',
      component: () => import('@/views/good-manage/good-group/list'),
      meta: {
        title: '商品分组',
        icon: 'goods',
      },
    },
    {
      path: 'good-list',
      meta: {
        title: '',
        icon: 'iconshangpin-',
      },
      name: 'good-list',
      component: () => import('@/views/good-manage/good-list/index.vue'),
      children: [
        {
          path: 'good-category',
          name: 'good-category',
          component: () => import('@/views/good-manage/good-list/category'),
          hidden: true,
          meta: {
            title: '发布商品',
            icon: 'goods',
          },
        },
        {
          path: 'index',
          name: 'good-list-index',
          component: () => import('@/views/good-manage/good-list/list'),
          meta: {
            title: '商品列表',
            icon: 'goods',
          },
        },
        {
          path: 'add-good',
          name: 'add-good',
          hidden: true,
          component: () =>
            import('@/views/good-manage/good-list/add-good/add-good.vue'),
          meta: {
            title: '商品添加',
            icon: 'goods',
          },
        },
        {
          path: 'good-modify',
          name: 'good-modify',
          hidden: true,
          component: () =>
            import('@/views/good-manage/good-modifyimport/index'),
          meta: {
            title: '批量导入修改商品',
            icon: 'goods',
          },
        },
        {
          path: '/',
          redirect: 'index',
          hidden: true,
        },
      ],
    },
    {
      path: 'good-classify',
      name: 'good-classify',
      component: () => import('@/views/good-manage/good-classify'),
      meta: {
        title: '',
        icon: 'goods',
      },
      children: [
        {
          path: 'relate-good',
          name: 'relate-good',
          component: () =>
            import('@/views/good-manage/good-classify/relate-good'),
          hidden: true,
          meta: {
            title: '关联商品',
            icon: 'goods',
          },
        },
        {
          path: 'index',
          name: 'good-classify-index',
          component: () =>
            import('@/views/good-manage/good-classify/list/list.vue'),
          meta: {
            title: '商品分类',
            icon: 'goods',
          },
        },
        {
          path: 'add-third-classify',
          name: 'add-third-classify',
          hidden: true,
          component: () =>
            import('@/views/good-manage/good-classify/add-third-classify'),
          meta: {
            title: '新增三级分类',
            icon: 'goods',
          },
        },
        {
          path: 'edit-brand',
          name: 'edit-brand',
          hidden: true,
          component: () =>
            import('@/views/good-manage/good-classify/edit-brand'),
          meta: {
            title: '编辑品牌墙',
            icon: 'goods',
          },
        },
        {
          path: '/',
          redirect: 'index',
          hidden: true,
        },
        //    path: `/good-manage/good-classify/edit-brand`,
      ],
    },
    {
      path: 'goods-brand',
      name: 'good-seller-brand',
      // component: () => import('@/views/user-manager/user-list'),
      meta: {
        title: '商品品牌',
        icon: 'goods',
      },
    },
    {
      path: 'commodity-management',
      name: 'goods-poster',
      // component: () => import('@/views/user-manager/user-list'),
      meta: {
        title: '商品公告',
        icon: 'goods',
      },
    },
  ],
};

// 订单管理路由
const orderManageRoutes = {
  path: '/order',
  name: 'order-layout',
  component: Layout,
  meta: {
    title: '订单管理',
    icon: 'icondingdan-',
  },
  children: [
    {
      path: 'index',
      name: 'order-main',
      component: () => import('@/views/order/list/main'),
      meta: {
        title: '全部订单',
        icon: 'dingdan',
      },
      children: [
        {
          path: 'list',
          name: 'order',
          hidden: true,
          component: () => import('@/views/order/list'),
          meta: {
            title: '订单列表',
            icon: 'dingdan',
          },
        },
        {
          path: '/grouplist',
          name: 'grouplist',
          hidden: true,
          component: () => import('@/views/order/list'),
          meta: {
            title: '同团订单列表',
            icon: 'dingdan',
          },
        },
        {
          path: 'detail',
          name: 'orderDetail',
          hidden: true,
          component: () => import('@/views/order/detail'),
          meta: {
            title: '订单详情',
            icon: 'dingdan',
          },
        },
        {
          path: 'refund',
          name: 'refund',
          hidden: true,
          component: () => import('@/views/order/refund'),
          meta: {
            title: '退款详情',
            icon: 'dingdan',
            hiddenMenu: true,
          },
        },
        {
          path: 'logistics',
          name: 'logistics',
          hidden: true,
          component: () => import('@/views/order/logistics'),
          meta: {
            title: '物流详情',
            icon: 'dingdan',
            hiddenMenu: true,
          },
        },
        {
          path: 'logisticsnum',
          name: 'logisticsnum',
          hidden: true,
          component: () => import('@/views/order/logisticsnum'),
          meta: {
            title: '导入运单',
            icon: 'dingdan',
          },
        },
        {
          path: 'order-modify',
          name: 'order-modify',
          hidden: true,
          component: () => import('@/views/order/order-modifyimport/index'),
          meta: {
            title: '批量发货',
            icon: 'order',
          },
        },

        {
          path: '/',
          redirect: 'list',
          hidden: true,
        },
      ],
    },
    {
      path: 'apply',
      name: 'apply',
      component: () => import('@/views/order/apply'),
      meta: {
        title: '申报订单',
        icon: 'dingdan',
      },
    },
    {
      path: 'applyByHandle',
      name: 'applyByHandle',
      component: () => import('@/views/order/applyByHandle'),
      meta: {
        title: '手动核验推订单',
        icon: 'dingdan',
      },
    },
    {
      path: 'config',
      name: 'orderConfig',
      meta: {
        title: '订单设置',
        icon: 'dingdan',
      },
    },
  ],
};

//分销路由
const stroeDistributeRoutes = {
  path: '/store-distribute',
  name: '/store-distribute',
  component: Layout,
  meta: {
    title: '门店分销',
    icon: 'icondingdan-',
  },
  children: [
    {
      path: 'saleslist',
      name: 'saleslist',
      meta: {
        title: '分销员管理',
        icon: 'icondingdan-',
      },
    },
    {
      path: 'salesgoods',
      name: 'salesgoods',
      meta: {
        title: '分销商品',
        icon: 'icondingdan-',
      },
    },
    {
      path: 'salesorder',
      name: 'salesorder',
      meta: {
        title: '订单',
        icon: 'icondingdan-',
      },
    },
    {
      path: 'saleswithdraw',
      name: 'saleswithdraw',
      meta: {
        title: '提现',
        icon: 'icondingdan-',
      },
    },
    {
      path: 'salesconfig',
      name: 'salesconfig',
      meta: {
        title: '设置',
        icon: 'icondingdan-',
      },
    },
  ]
}

// 商店设置路由
const settingRoutes = {
  path: '/shop-set',
  component: Layout,
  name: 'shop-set',
  meta: {
    title: '设置',
    icon: 'iconshangpin-',
  },
  children: [
    {
      path: 'freight-list',
      component: () => import('@/views/shop-set/freight-list/main.vue'),
      name: 'freight-list-main',
      meta: {
        title: '运费设置',
        icon: 'iconshangpin-',
      },
      children: [
        {
          path: 'list',
          hidden: true,
          component: () =>
            import('@/views/shop-set/freight-list/freight-list.vue'),
          name: 'freight-list',
          meta: {
            title: '',
            icon: 'iconshangpin-',
          },
        },
        {
          path: 'add-model',
          hidden: true,
          component: () => import('@/views/shop-set/add_model/add_model.vue'),
          name: 'add-model',
          meta: {
            title: '添加模块',
            icon: 'iconshangpin-',
          },
        },
        {
          path: 'update-model',
          hidden: true,
          component: () =>
            import('@/views/shop-set/update_model/update_model.vue'),
          name: 'update-model',
          meta: {
            title: '修改模块',
            icon: 'iconshangpin-',
          },
        },
        {
          path: '/',
          redirect: 'list',
          hidden: true,
        },
      ],
    },

    {
      path: 'trade-type-deploy',
      component: () =>
        import('@/views/shop-set/trade-type-deploy/trade-type-deploy.vue'),
      name: 'trade-type-deploy',
      meta: {
        title: '贸易类型配置',
        icon: 'iconshangpin-',
      },
    },
    {
      path: 'faq',
      meta: {
        title: '常见问题配置',
        icon: 'iconshangpin-',
      },
      name: 'faq',
      component: () => import('@/views/faq-manager/faq-list/index.vue'),
      children: [
        {
          path: 'list',
          name: 'faq-list',
          component: () => import('@/views/faq-manager/faq-list/list'),
          meta: {
            title: '',
            icon: 'iconshangpin-',
          },
          // children: [
          //   {
          //     path: 'category',
          //     name: 'faq-category',
          //     component: () => import('@/views/faq-manager/faq-list/category'),
          //     meta: {
          //       title: '编辑问题类别',
          //       icon: 'iconshangpin-',
          //     },
          //     hidden: true,
          //   },
          // ],
          hidden: true,
        },
        {
          path: 'category',
          name: 'faq-category',
          component: () => import('@/views/faq-manager/faq-list/category'),
          meta: {
            title: '编辑问题类别',
            icon: 'iconshangpin-',
          },
          hidden: true,
        },
        {
          path: 'add',
          name: 'faq-add',
          component: () => import('@/views/faq-manager/faq-list/add'),
          meta: {
            title: '新增常见问题',
            icon: 'iconshangpin-',
          },
          hidden: true,
        },
        {
          path: '/',
          redirect: 'list',
          hidden: true,
        },
      ],
    },
    {
      path: 'basic-set',
      component: () => import('@/views/shop-set/basic-set/basic-set'),
      name: 'basic-set',
      meta: {
        title: '基本配置',
        icon: 'iconshangpin-',
      },
    },
    {
      path: 'sms_manage',
      name: 'sms_manage',
      meta: {
        title: '短信验证码',
        icon: 'iconshangpin-',
      },
      component: () => import('@/views/shop-set/sms_record/index.vue'),
    },
    {
      path: 'auth_manage',
      name: 'auth_manage',
      meta: {
        title: '应用授权',
        icon: 'iconshangpin-',
      },
    },
  ],
};

// 营销管理路由
const marketingManagerRoutes = {
  path: '/marketing-manager',
  component: Layout,
  name: 'marketing-manager',
  meta: {
    title: '营销管理',
    icon: 'iconshangpin-',
    showOnlyOneChild: true,
  },
  children: [
    {
      path: '/marketing-campaign',
      component: () =>
        import(
          '@/views/marketing-campaign/marketing-activities/marketing-campaign'
        ),
      name: 'marketing-campaign',
      meta: {
        title: '营销活动',
        icon: 'iconshangpin-',
        showOnlyOneChild: true,
      },
      children: [
        {
          path: 'coupon-list',
          component: () =>
            import(
              '@/views/marketing-campaign/marketing-activities/coupon-list/coupon-list'
            ),
          name: 'coupon-list',
          hidden: true,
          meta: {
            title: '优惠券列表',
            icon: 'iconshangpin-',
            showOnlyOneChild: true,
          },
        },
        {
          path: 'coupon-detail',
          name: 'coupon-detail',
          hidden: true,
          component: () =>
            import(
              '@/views/marketing-campaign/marketing-activities/coupon-detail/coupon-detail'
            ),
          meta: {
            title: '优惠券详情',
            icon: 'goods',
          },
        },
        {
          path: 'reduction-postage-list',
          component: () =>
            import(
              '@/views/marketing-campaign/marketing-activities/reduction-postage-list/reduction-postage-list'
            ),
          name: 'reduction-postage-list',
          hidden: true,
          meta: {
            title: '满减邮',
            icon: 'iconshangpin-',
          },
          children: [
            {
              path: 'reduction-postage-edit',
              component: () =>
                import(
                  '@/views/marketing-campaign/marketing-activities/reduction-postage-edit/reduction-postage-edit'
                ),
              name: 'reduction-postage-edit',
              meta: {
                title: '编辑活动',
                titleFn: r =>
                  r.query.action === 'edit' ? '编辑活动' : '新建活动',
                icon: 'goods',
              },
            },
            {
              path: 'reduction-postage-manage-goods',
              name: 'reduction-postage-manage-goods',
              hidden: true,
              component: () =>
                import(
                  '@/views/marketing-campaign/marketing-activities/reduction-postage-manage-goods/reduction-postage-manage-goods'
                ),
              meta: {
                title: '管理活动商品',
                icon: 'goods',
              },
            },
            {
              path: 'add-activity-goods',
              name: 'add-activity-goods',
              hidden: true,
              component: () =>
                import(
                  '@/views/marketing-campaign/marketing-activities/reduction-postage-manage-goods/components/add-activity-goods'
                ),
              meta: {
                title: '添加活动商品',
                icon: 'goods',
              },
            },
          ],
        },
        // 领券活动路由
        {
          path: 'coupon-edit',
          name: 'coupon-edit',
          hidden: true,
          component: () =>
            import(
              '@/views/marketing-campaign/marketing-activities/coupon-edit/coupon-edit'
            ),
          meta: {
            title: '编辑优惠券',
            titleFn: r =>
              r.query.action === 'edit' ? '编辑优惠券' : '新增优惠券',
            icon: 'goods',
          },
        },
        // 满减送路由
        {
          path: 'reduction-postage-send-main',
          name: 'reduction-postage-send-main',
          component: () =>
            import(
              '@/views/marketing-campaign/marketing-activities/reduction-postage-send/main'
            ),
          hidden: true,
          meta: {
            title: '满减送',
            icon: 'iconshangpin-',
          },
          children: [
            {
              path: 'reduction-postage-send-index',
              name: 'reduction-postage-send-index',
              hidden: true,
              component: () =>
                import(
                  '@/views/marketing-campaign/marketing-activities/reduction-postage-send/index'
                ),
            },
            {
              path: 'add',
              name: 'reduction-postage-send-add',
              hidden: true,
              component: () =>
                import(
                  '@/views/marketing-campaign/marketing-activities/reduction-postage-send/components/add'
                ),
              meta: {
                titleFn: r =>
                  SEC_SEND_PAGE_TITLE[r.query.action] || '满减送活动页面',
                icon: 'goods',
              },
            },
          ],
        },
        // 限时秒杀路由
        {
          path: 'limit-time-seconds-kill-main',
          name: 'limit-time-seconds-kill-main',
          hidden: true,
          component: () =>
            import(
              '@/views/marketing-campaign/marketing-activities/limit-time-seconds-kill/main'
            ),
          meta: {
            title: '限时秒杀',
            icon: 'iconshangpin-',
          },
          children: [
            {
              path: 'limit-time-seconds-kill-index',
              name: 'limit-time-seconds-kill-index',
              hidden: true,
              component: () =>
                import(
                  '@/views/marketing-campaign/marketing-activities/limit-time-seconds-kill/index'
                ),
            },
            {
              path: 'add',
              name: 'limit-time-seconds-kill-add',
              hidden: true,
              component: () =>
                import(
                  '@/views/marketing-campaign/marketing-activities/limit-time-seconds-kill/components/add'
                ),
              meta: {
                // 配置了titleFn，可以不配置title
                titleFn: r =>
                  SEC_SEND_PAGE_TITLE[r.query.action] || '限时秒杀活动页面',
                icon: 'goods',
              },
            },
            {
              path: 'goods-manage',
              name: 'limit-time-seconds-kill-goods-manage',
              hidden: true,
              component: () =>
                import(
                  '@/views/marketing-campaign/marketing-activities/limit-time-seconds-kill/components/goods-manage'
                ),
              meta: {
                title: '活动商品管理',
                icon: 'goods',
              },
            },
          ],
        },
        // 微信商家券
        {
          path: 'wx-coupon-list',
          name: 'wx-coupon-list',
          component: () =>
            import(
              '@/views/marketing-campaign/marketing-activities/wx-coupon-list/wx-coupon-list'
            ),
          hidden: true,
          meta: {
            title: '微信商家券列表',
            icon: 'iconshangpin-',
            showOnlyOneChild: true,
          },
        },
        {
          path: 'wx-coupon-detail',
          name: 'wx-coupon-detail',
          hidden: true,
          component: () =>
            import(
              '@/views/marketing-campaign/marketing-activities/wx-coupon-detail/wx-coupon-detail'
            ),
          meta: {
            title: '微信商家券详情',
            icon: 'goods',
          },
        },
        {
          path: 'wx-coupon-edit',
          name: 'wx-coupon-edit',
          hidden: true,
          component: () =>
            import(
              '@/views/marketing-campaign/marketing-activities/wx-coupon-edit/wx-coupon-edit'
            ),
          meta: {
            title: '编辑微信商家券',
            titleFn: r =>
              r.query.action === 'edit' ? '编辑微信商家券' : '新增微信商家券',
            icon: 'goods',
          },
        },
      ],
    },
    {
      path: 'special-list',
      component: () =>
        import('@/views/shop-decoration/special-list/special-list.vue'),
      name: 'special-list',
      meta: {
        title: '专题列表',
        icon: 'iconshangpin-',
      },
    },
    {
      path: 'voucher-activity',
      name: 'voucher-activity-main',
      component: () =>
        import('@/views/marketing-campaign/voucher-activity/main'),
      meta: {
        title: '领券活动',
        icon: 'goods',
      },
      children: [
        {
          path: 'index',
          name: 'voucher-activity-list',
          component: () =>
            import('@/views/marketing-campaign/voucher-activity/index'),
          hidden: true,
          meta: {
            title: '领券活动列表',
            icon: 'goods',
          },
        },
        {
          path: 'voucher-activity-edit',
          name: 'voucher-activity-edit',
          component: () =>
            import(
              '@/views/marketing-campaign/voucher-activity/voucher-activity-edit/index'
            ),
          hidden: true,
          meta: {
            title: '编辑领券活动',
            titleFn: r =>
              r.query.action === 1 ? '编辑领券活动' : '新增领券活动',
            icon: 'goods',
          },
        },
        {
          path: '/',
          redirect: 'index',
          hidden: true,
        },
      ],
    },

    // 领券活动路由
    {
      path: 'start-ad-page',
      name: 'start-ad-page-main',
      meta: {
        title: '启动广告页',
        icon: 'goods',
      },
      component: () => import('@/views/marketing-campaign/start-ad-page/main'),
      children: [
        {
          path: 'index',
          name: 'start-ad-page',
          component: () =>
            import('@/views/marketing-campaign/start-ad-page/start-ad-page'),
          hidden: true,
          meta: {
            title: '启动广告页列表',
            icon: 'goods',
          },
        },
        {
          path: 'add-ad-page',
          name: 'add-ad-page',
          hidden: true,
          component: () =>
            import('@/views/marketing-campaign/start-ad-page/add-ad-page'),
          meta: {
            title: '编辑广告页',
            titleFn: r =>
              r.query.action === 'edit' ? '编辑广告页' : '新增广告页',
            icon: 'goods',
          },
        },
        {
          path: '/',
          redirect: 'index',
          hidden: true,
        },
      ],
    },

    // 预约活动
    {
      path: 'offline-activities',
      name: 'offline-activities-main',
      meta: {
        title: '预约活动',
        icon: 'goods',
      },
      component: () =>
        import('@/views/marketing-campaign/offline-activities/main'),
      children: [
        {
          path: 'index',
          name: 'offline-activities',
          component: () =>
            import(
              '@/views/marketing-campaign/offline-activities/offline-activities'
            ),
          hidden: true,
          meta: {
            title: '预约活动列表',
            icon: 'goods',
          },
        },
        {
          path: 'detail-offline-activities',
          name: 'detail-offline-activities',
          hidden: true,
          component: () =>
            import(
              '@/views/marketing-campaign/offline-activities/detail-offline-activities'
            ),
          meta: {
            title: '查看活动',
            icon: 'goods',
          },
        },
        {
          path: 'user-offline-activities',
          name: 'user-offline-activities',
          hidden: true,
          component: () =>
            import(
              '@/views/marketing-campaign/offline-activities/user-offline-activities'
            ),
          meta: {
            title: '查看用户',
            icon: 'goods',
          },
        },
        {
          path: 'action-offline-activities',
          name: 'action-offline-activities',
          hidden: true,
          component: () =>
            import(
              '@/views/marketing-campaign/offline-activities/action-offline-activities'
            ),
          meta: {
            title: '预约活动',
            titleFn: r =>
              r.query.action === 'edit' ? '编辑预约活动' : '新增预约活动',
            icon: 'goods',
          },
        },
        {
          path: 'email-offline-activities',
          name: 'email-offline-activities',
          hidden: true,
          component: () =>
            import(
              '@/views/marketing-campaign/offline-activities/email-offline-activities'
            ),
          meta: {
            title: '邮件管理',
            icon: 'goods',
          },
        },
        {
          path: '/',
          redirect: 'index',
          hidden: true,
        },
      ],
    },
    {
      path: 'add-jiezhou-coupon',
      component: () =>
        import(
          '@/views/marketing-campaign/marketing-activities/jiezhou-coupon-edit/coupon-edit'
        ),
      name: 'add-jiezhou-coupon',
      meta: {
        title: '新增芥舟优惠券',
        icon: 'iconshangpin-',
      },
    },
    // 领券活动路由
    {
      path: 'advertModaLlist',
      name: 'advertModaLlist',
      meta: {
        title: '广告管理',
        icon: 'iconshangpin-',
      },
    },
  ],
};
// 用户管理路由
const userManagerRoutes = {
  path: '/user-manager',
  component: Layout,
  name: 'user-manager',
  meta: {
    title: '用户管理',
    icon: 'iconshangpin-',
  },
  children: [
    {
      path: 'user-list',
      name: 'user-list',
      component: () => import('@/views/user-manager/user-list/main'),
      meta: {
        title: '全部用户',
        icon: 'dingdan',
      },
      children: [
        {
          path: 'index',
          name: 'user-list',
          component: () => import('@/views/user-manager/user-list'),
          hidden: true,
          meta: {
            title: '全部用户',
            icon: 'goods',
          },
        },
        {
          path: 'points-record',
          name: 'points-record',
          hidden: true,
          component: () => import('@/views/user-manager/points-record'),
          meta: {
            title: '积分明细',
            icon: 'dingdan',
          },
        },
        {
          path: '/',
          redirect: 'index',
          hidden: true,
        },
      ],
    },
    // {
    //   path: 'points-record',
    //   name: 'points-record',
    //   hidden: true,
    //   component: () =>import('@/views/user-manager/points-record'),
    //   meta: {
    //     title: '积分明细',
    //     icon: 'dingdan',
    //   },
    // },
    // 跳转到外部链接
    {
      path: 'member-level',
      name: 'member-level',
      // component: () => import('@/views/user-manager/user-list'),
      meta: {
        title: '会员等级',
        icon: 'dingdan',
      },
    },
    {
      path: 'member-rights',
      name: 'member-rights',
      // component: () => import('@/views/user-manager/user-list'),
      meta: {
        title: '会员权益',
        icon: 'dingdan',
      },
    },
    {
      path: 'integral-manage',
      name: 'integral-manage',
      // component: () => import('@/views/user-manager/user-list'),
      meta: {
        title: '积分管理',
        icon: 'dingdan',
      },
    },
    {
      path: '',
    },
  ],
};
// 数据中心路由
const dataCenterRoutes = {
  path: '/data-center',
  component: Layout,
  name: 'data-center',
  meta: {
    title: '数据',
    icon: 'iconshangpin-',
  },
  children: [
    {
      path: 'overview',
      name: 'overview',
      component: () => import('@/views/data-center/overview'),
      meta: {
        title: '数据概览',
        icon: 'dingdan',
      },
    },
    {
      path: 'transaction',
      name: 'transaction',
      component: () => import('@/views/data-center/transaction'),
      meta: {
        title: '交易分析',
        icon: 'dingdan',
      },
    },
    {
      path: 'market-situation',
      name: 'market-situation',
      component: () => import('@/views/data-center/market-situation/myindex'),
      meta: {
        title: '营销总况',
        icon: 'dingdan',
      },
    },
  ],
};

// 门店列表
const storeManageRoutes = {
  path: '/store-manage',
  component: Layout,
  name: 'store-manage',
  meta: {
    title: '门店管理',
    icon: 'iconshangpin-',
  },
  children: [
    {
      path: 'store-list',
      name: 'store-manage',
      component: () => import('@/views/store-manage/main'),
      meta: {
        title: '门店列表',
        icon: 'dingdan',
      },
      children: [
        {
          path: '',
          name: 'store-list',
          hidden: true,
          component: () => import('@/views/store-manage/index'),
          meta: {
            title: '',
            icon: 'dingdan',
          },
        },
        {
          path: 'store-add',
          name: 'store-add',
          hidden: true,
          component: () => import('@/views/store-manage/components/store-add'),
          meta: {
            title: '门店新增',
            icon: 'dingdan',
            titleFn: r => (r.query.action === 1 ? '门店编辑' : '门店新增'),
          },
        },
      ],
    },
  ],
};

// 账号及权限管理
const jurisdictionManagerRoutes = {
  path: '/jurisdiction-manager',
  component: Layout,
  name: 'jurisdiction-manager',
  meta: {
    title: '账号及权限管理',
    icon: 'iconshangpin-',
  },
  children: [
    {
      path: 'station-list',
      name: 'station-list-main',
      component: () => import('@/views/jurisdiction-manager/station-list/main'),
      meta: {
        title: '岗位管理',
        icon: 'dingdan',
      },
      children: [
        {
          path: 'index',
          name: 'station-list',
          component: () => import('@/views/jurisdiction-manager/station-list'),
          meta: {
            title: '',
            icon: 'dingdan',
          },
          hidden: true,
        },
        {
          path: 'station-detail',
          name: 'station-detail',
          component: () =>
            import('@/views/jurisdiction-manager/station-list/station-detail'),
          meta: {
            title: '编辑岗位',
            titleFn: r => (r.query.action === 1 ? '编辑岗位' : '新建岗位'),
            icon: 'dingdan',
          },
          hidden: true,
        },
        {
          path: 'station-school',
          name: 'station-school',
          component: () =>
            import(
              '@/views/jurisdiction-manager/station-list/station-school/index.vue'
            ),
          meta: {
            title: '关联学校',
            icon: 'dingdan',
          },
          hidden: true,
        },
        {
          path: '/',
          redirect: 'index',
          hidden: true,
        },
      ],
    },
    {
      path: 'account-list',
      name: 'account-list-main',
      component: () => import('@/views/jurisdiction-manager/account-list/main'),
      meta: {
        title: '账号管理',
        icon: 'dingdan',
      },
      children: [
        {
          path: 'index',
          name: 'account-list',
          component: () => import('@/views/account/index'),
          meta: {
            title: '',
            icon: 'dingdan',
          },
          hidden: true,
        },
        {
          path: 'account-detail',
          name: 'account-detail',
          component: () => import('@/views/account/edit'),
          meta: {
            title: '编辑账号',
            titleFn: r => (r.query.action === 1 ? '编辑账号' : '新建账号'),
            icon: 'dingdan',
          },
          hidden: true,
        },
        {
          path: '/',
          redirect: 'index',
          hidden: true,
        },
      ],
    },
  ],
};
// 留学缴费
const payAbrodManagerRoutes = {
  path: '/pay-manager',
  component: Layout,
  name: 'pay-manager',
  meta: {
    title: '学費決済',
    icon: 'iconshangpin-',
  },
  children: [
    {
      path: 'school-list',
      name: 'school-list-main',
      component: () => import('@/views/pay-manager'),
      meta: {
        title: '学校管理',
        icon: 'dingdan',
      },
      children: [
        {
          path: 'index',
          name: 'school-list',
          component: () => import('@/views/pay-manager/school-manager/main'),
          meta: {
            title: '',
            icon: 'dingdan',
          },
          hidden: true,
        },
        {
          path: 'school-detail',
          name: 'school-detail',
          component: () =>
            import('@/views/pay-manager/school-manager/school-detail'),
          meta: {
            title: '新增学校',
            titleFn: r => (r.query.action === 1 ? '编辑学校' : '新增学校'),
            icon: 'dingdan',
          },
          hidden: true,
        },
        {
          path: '/',
          redirect: 'index',
          hidden: true,
        },
      ],
    },
    {
      path: 'pay-list',
      name: 'pay-list',
      component: () => import('@/views/pay-manager/pay-list'),
      meta: {
        title: '学費決済履歴',
        icon: 'dingdan',
      },
    },
  ],
};

// 推广
const shopRemote = {
  path: '/shop-remote',
  component: Layout,
  name: 'shop-remote',
  meta: {
    title: '推广',
    icon: 'iconshangpin-',
  },
  children: [
    {
      path: 'shop-remote-info',
      name: 'shop-remote-info',
      meta: {
        title: '商品/券/活动推广',
        icon: 'dingdan',
      },
    },
  ],
};

// 腾讯地图
const qqMapRoutes = {
  path: '/qq-maps',
  component: () => import('@/views/qq-map/qq-map-targeted.vue'),
  hidden: true,
  meta: {
    title: '到店路线',
    icon: 'iconshangpin-',
  },
  children: [],
};

// 供应商
const supplierRemote = {
  path: 'supplier-account',
  name: 'supplier-account',
  component: Layout,
  meta: {
    title: '我的账户',
    icon: 'iconshangpin-',
  },
  children: [
    {
      path: 'supplier-account',
      name: 'supplier-account',
      hidden: true,
    },
  ],
};

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    name: 'Home',
    hidden: true,
    children: [
      {
        path: 'home',
        component: () => import('@/views/home/index'),
      },
    ],
  },
  /* 用户账号信息 */
  {
    path: '/account/',
    component: Layout,
    redirect: '/account',
    name: 'Account',
    hidden: true,
    children: [
      {
        path: '/',
        component: () => import('@/views/user-account/index'),
      },
    ],
  },
  storeProfileRoutes, // 店铺概况路由
  shopManageRoutes, // 店铺管理路由
  goodManageRoutes, // 商品管理路由
  distributionRoutes, // 分销市场路由
  orderManageRoutes, // 订单管理路由
  stroeDistributeRoutes, //分销路由
  settingRoutes, // 设置路由
  marketingManagerRoutes, // 营销管理路由
  userManagerRoutes, // 用户管理路由
  storeManageRoutes, // 门店管理路由
  dataCenterRoutes, // 数据路由
  jurisdictionManagerRoutes, // 权限管理
  payAbrodManagerRoutes, // 缴费管理
  shopRemote, // 推广
  qqMapRoutes, // 腾讯地图
  cpcAdsRoutes, // CPC广告投放
  supplierRemote, //供应商
  {
    path: '/registerAgreement',
    component: () => import('@/views/agreements/register.vue'),
    hidden: true,
  },
  {
    path: '/privacyAgreement',
    component: () => import('@/views/agreements/privacy.vue'),
    hidden: true,
  },
  {
    path: '/mini/privacyAgreement',
    component: () => import('@/views/agreements/miniProtocol.vue'),
    hidden: true,
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true,
  },
  // 404 page must be placed at the end !!!
  {
    path: '*',
    redirect: '/404',
    hidden: true,
  },
];

/**
 * @des 处理子路由和父路由的关联字段parentList, 最终该字段关联其祖先路由name
 */
const convertRecursiveAuthTree = (list, parentList = []) => {
  if (!list || list?.length === 0) return null;
  return list
    .map(t => {
      return {
        name: t.name,
        meta: t.meta,
        parentList: parentList,
        children: convertRecursiveAuthTree(
          t.children,
          parentList.concat(t.name)
        ),
      };
    })
    .filter(t => t.name && t.meta);
};
export const routerAuthTree = convertRecursiveAuthTree(constantRoutes);
// flatten it
const treeResult = [];
(() => {
  const flattenAuthTree = list => {
    if (!list) return null;
    return list.map(t => {
      treeResult.push(t);
      const k = flattenAuthTree(t.children);
      if (k) {
        treeResult.push(t);
      }
    });
  };
  flattenAuthTree(routerAuthTree);
})();
/**
 * @des 将路由打散成一维数组
 * */
export const routerAuthFlattened = treeResult;

const createRouter = () =>
  new Router({
    mode: 'history', // require service support
    //  scrollBehavior: () => ({ y: 0, x: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;

// Hamburger
